import { render, staticRenderFns } from "./StockRSIView.vue?vue&type=template&id=4521c642&scoped=true"
import script from "./StockRSIView.vue?vue&type=script&lang=js"
export * from "./StockRSIView.vue?vue&type=script&lang=js"
import style0 from "./StockRSIView.vue?vue&type=style&index=0&id=4521c642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4521c642",
  null
  
)

export default component.exports